import { Fulfillment } from '@/types/fulfillment';

// Fulfillment placeholder data
export const PLACEHOLDER_FULFILLMENT: Fulfillment[] = [
  {
    id: '1',
    name: 'Website Redesign',
    title: 'Website Redesign',
    description: 'Overhaul the company website with a modern design and improved UX',
    project_type: 'Web Development',
    company: 'TechCorp',
    contact: 'Alex Johnson',
    status: 'development',
    target_completion_date: '2025-05-15',
    team: ['Jane Doe', 'John Smith', 'Alice Brown'],
    progress: 65
  },
  {
    id: '2',
    name: 'Mobile App Development',
    title: 'Mobile App Development',
    description: 'Create a cross-platform mobile application for customer engagement',
    project_type: 'Mobile Development',
    company: 'MediHealth',
    contact: 'Sam Taylor',
    status: 'design',
    target_completion_date: '2025-06-30',
    team: ['Bob White', 'Sarah Green', 'Mike Blue', 'Lisa Gray'],
    progress: 40
  },
  {
    id: '3',
    name: 'Analytics Dashboard',
    title: 'Analytics Dashboard',
    description: 'Build a real-time analytics dashboard for executive reporting',
    project_type: 'Data Analytics',
    company: 'InvestGroup',
    contact: 'Jordan Rivera',
    status: 'planning',
    target_completion_date: '2025-07-10',
    team: ['Chris Purple', 'Emma Yellow'],
    progress: 15
  },
  {
    id: '4',
    name: 'E-commerce Platform',
    title: 'E-commerce Platform',
    description: 'Build a scalable online shopping platform with inventory management',
    project_type: 'E-commerce',
    company: 'RetailPlus',
    contact: 'Morgan Chen',
    status: 'testing',
    target_completion_date: '2025-05-30',
    team: ['David Orange', 'Olivia Red', 'Tom Black'],
    progress: 85
  },
  {
    id: '5',
    name: 'Brand Identity Refresh',
    title: 'Brand Identity Refresh',
    description: 'Update visual identity including logo, colors, and brand guidelines',
    project_type: 'Branding',
    company: 'EcoSolutions',
    contact: 'Jamie Wilson',
    status: 'approval',
    target_completion_date: '2025-04-25',
    team: ['Rachel Pink', 'Nathan Brown'],
    progress: 90
  },
  {
    id: '6',
    name: 'CRM Integration',
    title: 'CRM Integration',
    description: 'Integrate customer relationship management system with existing platforms',
    project_type: 'Integration',
    company: 'TechCorp',
    contact: 'Alex Johnson',
    status: 'discovery',
    target_completion_date: '2025-07-15',
    team: ['Mark Gold', 'Sophia Silver'],
    progress: 10
  },
  {
    id: '7',
    name: 'Content Management System',
    title: 'Content Management System',
    description: 'Implement a custom CMS for easy content updates and management',
    project_type: 'CMS Development',
    company: 'MediHealth',
    contact: 'Sam Taylor',
    status: 'scoping',
    target_completion_date: '2025-06-10',
    team: ['Ryan Teal', 'Natalie Cyan'],
    progress: 25
  },
  {
    id: '8',
    name: 'Payment Gateway Integration',
    title: 'Payment Gateway Integration',
    description: 'Add secure payment processing capabilities to existing platform',
    project_type: 'Payment Systems',
    company: 'RetailPlus',
    contact: 'Morgan Chen',
    status: 'proposal',
    target_completion_date: '2025-05-20',
    team: ['Victor Violet', 'Penelope Plum'],
    progress: 30
  },
  {
    id: '9',
    name: 'Security Audit & Implementation',
    title: 'Security Audit & Implementation',
    description: 'Comprehensive security review and implementation of best practices',
    project_type: 'Security',
    company: 'InvestGroup',
    contact: 'Jordan Rivera',
    status: 'review',
    target_completion_date: '2025-06-05',
    team: ['Howard Hazel', 'Irene Ivory'],
    progress: 80
  },
  {
    id: '10',
    name: 'Cloud Migration',
    title: 'Cloud Migration',
    description: 'Migrate on-premise infrastructure to cloud-based solutions',
    project_type: 'Cloud Infrastructure',
    company: 'EcoSolutions',
    contact: 'Jamie Wilson',
    status: 'deployment',
    target_completion_date: '2025-04-30',
    team: ['Quentin Quartz', 'Ursula Umber'],
    progress: 95
  },
  {
    id: '11',
    name: 'Staff Training Program',
    title: 'Staff Training Program',
    description: 'Develop and deliver comprehensive training for new systems',
    project_type: 'Training',
    company: 'MediHealth',
    contact: 'Sam Taylor',
    status: 'training',
    target_completion_date: '2025-07-25',
    team: ['Xavier Xanthic', 'Yvonne Yellow'],
    progress: 70
  },
  {
    id: '12',
    name: 'Ongoing Maintenance',
    title: 'Ongoing Maintenance',
    description: 'Regular updates, security patches, and performance optimization',
    project_type: 'Maintenance',
    company: 'TechCorp',
    contact: 'Alex Johnson',
    status: 'support',
    target_completion_date: '2025-12-31',
    team: ['Zach Zinc', 'Wendy White'],
    progress: 50
  },
  {
    id: '13',
    name: 'Social Media Strategy',
    title: 'Social Media Strategy',
    description: 'Develop comprehensive social media presence and content calendar',
    project_type: 'Digital Marketing',
    company: 'RetailPlus',
    contact: 'Morgan Chen',
    status: 'discovery',
    target_completion_date: '2025-06-15',
    team: ['Adam Azure', 'Betty Beige'],
    progress: 5
  },
  {
    id: '14',
    name: 'Data Analytics Platform',
    title: 'Data Analytics Platform',
    description: 'Build custom analytics solution for business intelligence',
    project_type: 'Data Analytics',
    company: 'InvestGroup',
    contact: 'Jordan Rivera',
    status: 'development',
    target_completion_date: '2025-08-10',
    team: ['Charlie Crimson', 'Donna Diamond'],
    progress: 60
  },
  {
    id: '15',
    name: 'Mobile App Phase 2',
    title: 'Mobile App Phase 2',
    description: 'Add advanced features and functionality to existing mobile app',
    project_type: 'Mobile Development',
    company: 'MediHealth',
    contact: 'Sam Taylor',
    status: 'planning',
    target_completion_date: '2025-09-15',
    team: ['Edward Emerald', 'Fiona Fuchsia'],
    progress: 20
  }
];
